import { onLoadComplete } from './_utils';
import each from 'lodash/each';
const selectors = {
	hotelCapacityCharts: '.HotelCapacityCharts--js',
	hotelCapacityChart: '.HotelCapacityChart--js',
	hotelCapacityChartsUnitSelect: '.HotelCapacityCharts-unitSelect--js',
	accordionClass: `.Accordion`,
	accordionItemButton: '.Accordion-item-button',
	sqMUnitValues: '[data-unit="sqM"]',
	sqFtUnitValues: '[data-unit="sqFt"]',
};

const setUnit = function (unit) {
	const allHotelCapacityCharts = document.querySelectorAll(selectors.hotelCapacityChart);
	each(allHotelCapacityCharts, hotelCapacityChart => {
		const allSqMUnitValues = hotelCapacityChart.querySelectorAll(selectors.sqMUnitValues);
		const allSqFtUnitValues = hotelCapacityChart.querySelectorAll(selectors.sqFtUnitValues);

		each(allSqMUnitValues, sqMUnitValue => {
			sqMUnitValue.style.display = unit == 'sqM' ? 'block' : 'none';
		});

		each(allSqFtUnitValues, sqFtUnitValue => {
			sqFtUnitValue.style.display = unit == 'sqFt' ? 'block' : 'none';
		});
	});
};

const expandAccordions = () => {
	if (window.innerWidth >= 1100) {
		const allHotelCapacityCharts = document.querySelectorAll(selectors.hotelCapacityCharts);

		each(allHotelCapacityCharts, hotelCapacityChart => {
			const accordion = hotelCapacityChart.querySelector(selectors.accordionClass);
			$(accordion).on('startup.accordion', () => {
				const allAccordionItemButtons = accordion.querySelectorAll(
					selectors.accordionItemButton
				);

				each(allAccordionItemButtons, accordionItemButton => {
					$(accordionItemButton).trigger('expand.accordion');
				});
			});
		});
	}
};

export default function hotelCapacityCharts() {
	const defaultUnit = 'sqM';
	setUnit(defaultUnit);

	const hotelCapacityChartsUnitSelect = document.querySelector(
		selectors.hotelCapacityChartsUnitSelect
	);
	if (hotelCapacityChartsUnitSelect) {
		hotelCapacityChartsUnitSelect.addEventListener('change', e => {
			setUnit(e.target.value);
			window.dispatchEvent(new CustomEvent('unitChange'));
		});
	}
	onLoadComplete(expandAccordions);
}
